import { render } from "./DashboardSummary.vue?vue&type=template&id=459b85da&ts=true"
import script from "./DashboardSummary.vue?vue&type=script&lang=ts"
export * from "./DashboardSummary.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__